import { render, staticRenderFns } from "./EditRolePermissions.vue?vue&type=template&id=79beb6a2&scoped=true"
import script from "./EditRolePermissions.vue?vue&type=script&lang=js"
export * from "./EditRolePermissions.vue?vue&type=script&lang=js"
import style0 from "./EditRolePermissions.vue?vue&type=style&index=0&id=79beb6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79beb6a2",
  null
  
)

export default component.exports